import * as React from "react";
import { bannerQrcodeImg, FOOTER_CONTENT, SEO } from "@/constants/wxHomepage";
import { Footer } from "@/components";
import { WxOurInfomation } from "../../components/our-infomation";
import { WxBanner } from "../../components/wx-banner";
import { HorizontalCards } from "../../components/horizontal-cards";
import { VerticalCard } from "../../components/vertical-card";
import { TabCards } from "../../components/tab-cards";
import { genBlock } from "@/utils/bem";
import { isWap } from "@/utils/tools";
import "./index.less";

const HORIZONTAL_CARD = [
  {
    img: require("@/assets/images/wx/img/24@3x.png"),
    title: "生成渠道二维码",
    desc: (
      <span>
        针对不同渠道创建可统计关注人数
        <br />
        记录关注粉丝的渠道二维码
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/25@3x.png"),
    title: "查看统计数据",
    desc: (
      <span>
        可统计扫码总数、新/老粉丝扫码数
        <br />
        新粉占比；可查看粉丝数据趋势；
        <br />
        可导出统计数据
        <br />
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/26@3x.png"),
    title: "自定义回复内容",
    desc: (
      <span>
        设置扫码/关注后的回复内容
        <br />
        支持图文消息、链接组、智能文本
        <br />
        图片、小程序
        <br />
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/17@3x.png"),
    title: "小程序卡片",
    desc: (
      <span>
        扫码关注后直接发送小程序卡片
        <br />
        支持自定义标题和封面
      </span>
    ),
  },
];

const TAB_CARDS = [
  {
    img: require("@/assets/images/wx/img/tab-3.png"),
    icon: require("@/assets/images/wx/small-icon/23@3x.png"),
    title: "多条消息延时回复",
    desc: "扫码后回复多条消息，消息间可设置间隔时长",
  },
  {
    img: require("@/assets/images/wx/img/tab-4.png"),
    icon: require("@/assets/images/wx/small-icon/17@3x.png"),
    title: "扫码自动打标签",
    desc: "扫码成为粉丝后自动打上对应标签",
  },
  {
    img: require("@/assets/images/wx/img/tab-2.png"),
    icon: require("@/assets/images/wx/small-icon/16@3x.png"),
    title: "多种类型回复",
    desc: "以微信卡片的形式展示网址，更加直观",
  },
  {
    img: require("@/assets/images/wx/img/tab-1.png"),
    icon: require("@/assets/images/wx/small-icon/15@3x.png"),
    title: "不限制创建数量",
    desc: "创建渠道二维码数量不限制",
  },
];

const SCENE_DATA = [
  {
    imgUrl: require("@/assets/images/wx/icon/qudao.png"),
    align: "left" as "left",
    title: "渠道分析",
    descList: ["为不同活动生成专属二维码", "推送个性内容查看活动吸粉效果"],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/xianxia.png"),
    align: "left" as "left",
    title: "线下推广",
    descList: ["为推广人员配置不同二维码", "轻松考核"],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/baozhuang.png"),
    align: "left" as "left",
    title: "包装印刷",
    descList: ["在产品包装、宣传手册印制", "不同二维码统计吸粉效果"],
  },
];

const block = genBlock("wx-qr-code");

const WxQrCode: React.FC<{}> = () => {

  React.useEffect(() => {
    document.querySelector('meta[name="keywords"]').setAttribute('content', SEO['qr-code'].keyword);
    document.querySelector('meta[name="description"]').setAttribute('content', SEO['qr-code'].description);
  }, [])

  return (
    <div className={block()}>
      <WxBanner
        img={bannerQrcodeImg}
        btnText={"立即使用"}
        btnClick={isWap() ? null : "/v3/weixin/list"}
      />
      <HorizontalCards cards={HORIZONTAL_CARD} title={"功能特性"} />
      <TabCards
        title={"功能特色"}
        list={TAB_CARDS}
        style={{ backgroundColor: "#F8FBFF" }}
      />
      <div className={block("scene")}>
        <div className={block("scene-title")}>适用场景</div>
        <div className={block("scene-wrap")}>
          {/* <div className={block('scene-placeholder')}></div> */}
          {SCENE_DATA.map((item) => (
            <VerticalCard
              {...item}
              style={{ padding: "10px 20px 20px 30px" }}
            />
          ))}
        </div>
      </div>
      <WxOurInfomation />
      <Footer {...FOOTER_CONTENT} />
    </div>
  );
};

export default WxQrCode;
